import { COURSE_ORDER } from 'src/constants/eLearning'

export const initialState = {
  isLoadMore: false,
  isSuccess: false,
  filterData: null,
  filterBody: {
    order: COURSE_ORDER.DESC,
    sortBy: 'POPULAR',
    courseType: [],
    courseStatus: [],
    myCourse: [],
    acquiredSkill: [],
    productType: [],
    courseName: '',
    courseHourFrom: 0,
    courseHourTo: 0,
    startDate: '',
    finishDate: '',
    page: 1,
    limit: 12,
  },
  courses: [],
  likeCourses: [],
  totalCourses: 0,
  totalLikeCourses: 0,
  error: null,
}
